import { render, staticRenderFns } from "./GuiasCriticasDlg.vue?vue&type=template&id=5a8a9aa4"
import script from "./GuiasCriticasDlg.vue?vue&type=script&lang=js"
export * from "./GuiasCriticasDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports